function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { isEmpty, forEach, range } from "lodash";
import { getSelectedRowsFromEntities } from "./selection";
import getIdOrCodeOrIndex from "./getIdOrCodeOrIndex";
import { getRecordsFromIdMap } from "./withSelectedEntities";
export default function rowClick(e, rowInfo, entities, props) {
  var _newIdMap;

  var reduxFormSelectedEntityIdMap = props.reduxFormSelectedEntityIdMap,
      isSingleSelect = props.isSingleSelect,
      noSelect = props.noSelect,
      onRowClick = props.onRowClick,
      isEntityDisabled = props.isEntityDisabled,
      withCheckboxes = props.withCheckboxes;
  var entity = rowInfo.original;
  onRowClick(e, entity, rowInfo);
  if (noSelect || isEntityDisabled(entity)) return;
  var rowId = getIdOrCodeOrIndex(entity, rowInfo.index);
  if (rowId === undefined) return;
  var ctrl = e.metaKey || e.ctrlKey || withCheckboxes && !e.shiftKey;
  var oldIdMap = reduxFormSelectedEntityIdMap || {};
  var rowSelected = oldIdMap[rowId];
  var newIdMap = (_newIdMap = {}, _newIdMap[rowId] = {
    time: Date.now(),
    entity: entity
  }, _newIdMap);

  if (isSingleSelect) {
    if (rowSelected) newIdMap = {};
  } else if (rowSelected && e.shiftKey) return;else if (rowSelected && ctrl) {
    newIdMap = _extends({}, oldIdMap);
    delete newIdMap[rowId];
  } else if (rowSelected) {
    newIdMap = {};
  } else if (ctrl) {
    newIdMap = _extends({}, oldIdMap, newIdMap);
  } else if (e.shiftKey && !isEmpty(oldIdMap)) {
    var _newIdMap2;

    newIdMap = (_newIdMap2 = {}, _newIdMap2[rowId] = {
      entity: entity,
      time: Date.now()
    }, _newIdMap2);
    var currentlySelectedRowIndices = getSelectedRowsFromEntities(entities, oldIdMap);

    if (currentlySelectedRowIndices.length) {
      var timeToBeat = {
        id: null,
        time: null
      };
      forEach(oldIdMap, function (_ref, key) {
        var time = _ref.time;
        if (time && time > timeToBeat.time) timeToBeat = {
          id: key,
          time: time
        };
      });
      var mostRecentlySelectedIndex = entities.findIndex(function (e, i) {
        var id = getIdOrCodeOrIndex(e, i);
        if (!id && id !== 0) id = "";
        return id.toString() === timeToBeat.id;
      });

      if (mostRecentlySelectedIndex !== -1) {
        var highRange = rowInfo.index < mostRecentlySelectedIndex ? mostRecentlySelectedIndex - 1 : rowInfo.index;
        var lowRange = rowInfo.index > mostRecentlySelectedIndex ? mostRecentlySelectedIndex + 1 : rowInfo.index;
        range(lowRange, highRange + 1).forEach(function (i) {
          if (isEntityDisabled && isEntityDisabled(entities[i])) {
            return;
          }

          var recordId = entities[i] && getIdOrCodeOrIndex(entities[i], i);
          if (recordId || recordId === 0) // newIdMap[recordId] = { entity: entities[i] };
            newIdMap[recordId] = {
              entity: entities[i],
              time: Date.now()
            };
        });
        newIdMap = _extends({}, oldIdMap, newIdMap);

        if (newIdMap[rowId]) {
          //the entity we just clicked on should have the "freshest" time
          newIdMap[rowId].time = Date.now() + 1;
        }
      }
    }
  }

  finalizeSelection({
    idMap: newIdMap,
    entities: entities,
    props: props
  });
}
export function changeSelectedEntities(_ref2) {
  var idMap = _ref2.idMap,
      _ref2$entities = _ref2.entities,
      entities = _ref2$entities === void 0 ? [] : _ref2$entities,
      change = _ref2.change;

  var newIdMap = _extends({}, idMap);

  var entityIdToIndex = {};
  entities.forEach(function (e, i) {
    entityIdToIndex[getIdOrCodeOrIndex(e, 0)] = i;
  }); // we want to store the index of the entity so that it can be used to preserve order in selection

  Object.keys(newIdMap).forEach(function (key) {
    if (!newIdMap[key]) return;
    var rowIndex = entityIdToIndex[getIdOrCodeOrIndex(newIdMap[key].entity, 0)];
    newIdMap[key] = _extends({}, newIdMap[key], {
      rowIndex: rowIndex === undefined ? 10000000 : rowIndex
    });
  });
  change("reduxFormSelectedEntityIdMap", newIdMap);
}
export function finalizeSelection(_ref3) {
  var idMap = _ref3.idMap,
      entities = _ref3.entities,
      props = _ref3.props;
  var onDeselect = props.onDeselect,
      onSingleRowSelect = props.onSingleRowSelect,
      onMultiRowSelect = props.onMultiRowSelect,
      noDeselectAll = props.noDeselectAll,
      onRowSelect = props.onRowSelect,
      noSelect = props.noSelect,
      change = props.change;
  if (noSelect) return;

  if (noDeselectAll && Object.keys(idMap).filter(function (id) {
    return idMap[id];
  }).length === 0) {
    return;
  }

  changeSelectedEntities({
    idMap: idMap,
    entities: entities,
    change: change
  });
  var selectedRecords = getRecordsFromIdMap(idMap);
  onRowSelect(selectedRecords);
  selectedRecords.length === 0 ? onDeselect() : selectedRecords.length > 1 ? onMultiRowSelect(selectedRecords) : onSingleRowSelect(selectedRecords[0]);
}